/**
 * Store for keeping observables in memory. Typical usecase is to share observables across multiple
 * components or to retrieve an observable when reconstructing a component.
 */

import * as ko from "knockout";

export class MemoryStore {
    private store: { [key: string]: KnockoutObservable<any> } = {};

    get(storeId: string, defaultValue: any = null): KnockoutObservable<any> {
        if (!this.isSet(storeId)) {
            this.store[storeId] = ko.observable(defaultValue);
        }

        return this.store[storeId]!;
    }

    getVal(storeId: string): any {
        return this.get(storeId)();
    }

    isSet(storeId: string): boolean {
        return storeId in this.store;
    }
    
    removeAll() {
        for (let storeKey in this.store) {
            delete this.store[storeKey]
        }
    }
}

export let memoryStore = new MemoryStore();
